module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,UPRAWN_UDT_Bielsko_Biala_dot_napraw_rurociagow__zbiornikow_itp__VI_2015.56d0a22c.jpeg";